import ENTERPRISE from "images/sponsors/enterprise.png"
import GRAHAM_FOUNDATION from "images/sponsors/graham-foundation.png"
import IDEO from "images/sponsors/ideo.png"
import PERKINS_WILL from "images/sponsors/perkins-will.png"
import SAM_SCHWARTZ from "images/sponsors/sam-schwartz.png"
import STULL_LEE from "images/sponsors/stull-lee.png"
import HARVARD_SOE from "images/sponsors/harvard-soe.png"

const Logos = [
  { logo: GRAHAM_FOUNDATION, url: "http://grahamfoundation.org/" },
  { logo: PERKINS_WILL, url: "https://perkinswill.com/" },
  { logo: IDEO, url: "https://www.ideo.com/" },
  { logo: SAM_SCHWARTZ, url: "http://samschwartz.com/" },
  { logo: ENTERPRISE, url: "https://www.enterprisecommunity.org/rose" },
  { logo: STULL_LEE, url: "http://stullandlee.com/" },
  { logo: HARVARD_SOE, url: "https://www.seas.harvard.edu/" },
]

export default Logos
